<template>
  <div class="kw_list_default" :style="pageSetInfo.listStyleSet.listPageBoxStyleSet?pageSetInfo.listStyleSet.listPageBoxStyleSet.styleSetCode:''" kwName="listPageBoxStyleSet">
    <template name="listDiv">
      <!-- 列表的table信息 v-fit-columns="listFieldSet" -->
      <el-table v-if="listFieldSet.length > 0" 
          ref="listTableRef"
          :data="dataList"
          :row-key="'T_' + pageSetInfo.tableId + '_0'"
          border
          highlight-current-row
          @row-click="tableRowClick"
          @row-dblclick="tableRowDblclick"
          @selection-change="tableSelectionChange"
          @sort-change="sortChange"
          :span-method="arraySpanMethod"
          size="mini"
          :header-row-style="getHeadRowStyle"
          :header-cell-style="getHeadCellStyle"
          :row-style="getRowStyle"
          :cell-style="getCellStyle"
          :style="'width: 100%;'+(pageSetInfo.listStyleSet.listPageCardBoxStyleSet?pageSetInfo.listStyleSet.listPageCardBoxStyleSet.styleSetCode:'')" kwName="listPageCardBoxStyleSet"
          :height="((pageSetInfo.listStyleSet.listPageCardBoxStyleSet&&pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height)?pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height:null)"
          :max-height="tableMaxHeight"
          :fit=true
          :stripe=true
          class="table_border_color_zdy"
          >
          <!-- 加号展开子表格的数据 -->
          <el-table-column v-if="pageSetInfo.childTabs.length > 0 && (!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.childTabShowWay!='2')" 
              type="expand" width="40" 
          >
              <template slot-scope="scope">
                  <el-tabs v-model="childTabChooseIndex" value="childTab_0">
                      <template v-for="(childTabOne,childTabIndex) in pageSetInfo.childTabs">
                        <el-tab-pane :key="'childTab_'+childTabIndex" v-if="scope.row['LIST_BLOCK_SHOW_'+childTabOne.pageId]!=0"
                            :label="childTabOne.childPageName" 
                            :name="'childTab_'+childTabIndex"
                        >
                            <kw_list :key="'childTabKwList_'+childTabIndex" :ref="'childTabKwList_'+childTabIndex" :initPageObj="{
                                'pageId':childTabOne.pageId,
                                'tableId':childTabOne.tableId,
                                'pageType':1,
                                'mainTableId':pageSetInfo.tableId,
                                'mainPageId':pageSetInfo.pageId
                            }" :mainId="scope.row['T_' + pageSetInfo.tableId + '_0']" :isLimitButton="isLimitButton"></kw_list>
                        </el-tab-pane>
                      </template>
                  </el-tabs>
              </template>
          </el-table-column>
          <el-table-column v-if="!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.indexIfShow!=2"
              type="index" label="#"
              :fixed="(pageSetInfo.childTabs.length > 0 && (!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.childTabShowWay!='2'))?null:'left'"
              :index="getListIndex" align="center"
              width="40">
          </el-table-column>
          <el-table-column v-if="(!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.radioIfShow!=2) && dataMaxNum!=1"
              type="selection" align="center"
              :fixed="(pageSetInfo.childTabs.length > 0 && (!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.childTabShowWay!='2'))?null:'left'"
              reserve-selection
              width="44">
          </el-table-column>
          <el-table-column v-if="pageSetInfo.operaButtonSetIfHide"
              :fixed="(pageSetInfo.childTabs.length > 0 && (!pageSetInfo.listStyleSet || pageSetInfo.listStyleSet.childTabShowWay!='2'))?null:'left'"
              label="操作" align="center" :class-name="'fit_column fit_column_class'"
              :width="buttonWidth">
              <template slot-scope="scope">
                    <div v-for="(buttonGroupOne,buttonGroupIndex) in buttonGroupList" :key="'buttonGroupIndex_'+buttonGroupIndex" style="display:inline;" >
                        <el-dropdown v-if="buttonGroupOne.isGroup" :trigger="visitSource==2?'hover':'click'" size="mini"
                                @command="dataButtonClick($event,scope.row)"
                        >
                            <el-button type="primary"
                                size="mini" style="padding:7px;"
                            >
                                {{buttonGroupOne.operaButtonSet[0].buttonTabName}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <template v-for="(operaButtonOne,operaButtonIndex) in buttonGroupOne.operaButtonSet">
                                    <el-dropdown-item :key="'operaButtonOne_'+operaButtonIndex"
                                        v-if="operaButtonOne.ifShow && (scope.row[operaButtonOne.butTjKey] != 0)"
                                        :command="operaButtonOne"
                                    >
                                        {{operaButtonOne.buttonName}}
                                    </el-dropdown-item>
                                </template>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-dropdown v-else-if="buttonGroupOne.operaButtonSet.length > 1" :trigger="visitSource==2?'hover':'click'" size="mini"
                                @command="dataButtonClick($event,scope.row)"
                        >
                            <el-button type="primary"
                                size="mini" style="padding:7px;"
                            >
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <template v-for="(operaButtonOne,operaButtonIndex) in buttonGroupOne.operaButtonSet">
                                    <el-dropdown-item :key="operaButtonIndex"
                                        v-if="operaButtonOne.ifShow && (scope.row[operaButtonOne.butTjKey] != 0)"
                                        :command="operaButtonOne"
                                    >
                                        {{operaButtonOne.buttonName}}
                                    </el-dropdown-item>
                                </template>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                        <el-button-group v-else>
                            <template v-for="(operaButtonOne,operaButtonIndex) in buttonGroupOne.operaButtonSet">
                                <el-button :key="'operaButtonOne_'+operaButtonIndex"
                                    v-if="operaButtonOne.ifShow && (scope.row[operaButtonOne.butTjKey] != 0)"
                                    @click="dataButtonClick(operaButtonOne,scope.row)" type="text" size="small" style="color: #f67613;margin: 0 2px;"
                                >
                                    {{operaButtonOne.buttonName}}
                                </el-button>
                            </template>
                        </el-button-group> 
                    </div>
              </template>
          </el-table-column>
            <template v-for="(fieldOne,fieldIndex) in listFieldSet">
                <el-table-column :key="'fieldIndex_'+fieldIndex"
                    :prop="(fieldOne.fieldType == 4?'DIC_':'')+fieldOne.fieldAliasName"
                    align="center"
                    :label="fieldOne.fieldCnName"
                    :sortable="(fieldOne.ifSort==1?'custom':false)"
                    :fixed="(fieldIndex < pageSetInfo.fixdRow)?true:false"
                    :min-width="fieldOne.listWidth+'px'"
                    :width="fieldOne.listWidth!=100?(fieldOne.listWidth>500?500:fieldOne.listWidth):''"
                    v-if="fieldOne.ifShowCol!=0 && (!fieldOne.styleSet || fieldOne.styleSet.cssStyle!=5)"
                    :class-name="((fieldOne.styleSet && fieldOne.styleSet.isLineFeed==1)?'':'fit_column ') + 'fieldIndex_'+fieldIndex + (fieldOne.listWidth>500?'':((fieldOne.styleSet && fieldOne.styleSet.isLineFeed==1)?'':' fit_column_class'))"
                >
                    <template slot="header">
                        <el-tooltip v-if="fieldOne.colTitle && fieldOne.colTitle.length > 0" class="item" effect="dark" :content="fieldOne.colTitle" placement="top">
                            <div>
                                {{fieldOne.fieldCnName}}
                            </div>
                        </el-tooltip>
                        <template v-else>
                            {{fieldOne.fieldCnName}}
                        </template>
                    </template>
                <!-- show-overflow-tooltip="true" -->
                    <template  slot-scope="scope">
                        <template v-if="fieldOne.styleSet.cssStyle > 1">
                            <kw_card_field :key="'fieldIndex_'+fieldIndex" :fieldInfo="fieldOne" :fieldIndex="fieldIndex" :dataInfo="scope.row" :pageSetInfo="pageSetInfo" :isHaving="0"  :dataIndex="scope.$index"></kw_card_field>
                        </template>
                        <!-- <div v-else-if="(fieldOne.styleSet.cssStyle == 3)" >
                            <kw_having_view :initDataInfo="scope.row" :initPageSetInfo="pageSetInfo" :item="fieldOne"></kw_having_view>
                        </div>
                        <div v-else-if="(fieldOne.styleSet.cssStyle == 12||fieldOne.styleSet.cssStyle == 14)" class="bgImageThreeBox" :style="fieldOne.styleSet.listFieldStyleSet?fieldOne.styleSet.listFieldStyleSet.styleSetCode:''" kwName="listFieldStyleSet">
                            <kw_preview_image v-for="(bgFileInfo,imgIndex) in scope.row[fieldOne.fieldAliasName]" :key="'imageIndex_'+imgIndex" :styleSet="fieldOne.styleSet" :imgSrc="bgFileInfo" :class="scope.row[fieldOne.fieldAliasName].length==1?'bgImageOne':'bgImageThree'"></kw_preview_image>
                        </div>
                        <div v-else-if="(fieldOne.styleSet.cssStyle == 15)" :style="fieldOne.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">
                            <vue-qr :text="scope.row[fieldOne.fieldAliasName]" :size="(fieldOne.styleSet.listFieldValueStyleSet&&fieldOne.styleSet.listFieldValueStyleSet.width)?fieldOne.styleSet.listFieldValueStyleSet.width:200" :margin="(fieldOne.styleSet.listFieldValueStyleSet&&fieldOne.styleSet.listFieldValueStyleSet.margin)?fieldOne.styleSet.listFieldValueStyleSet.margin.replace('px','')*1:5"></vue-qr>
                        </div>
                        <div v-else-if="(fieldOne.styleSet.cssStyle == 16)" :style="fieldOne.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">
                            <barcode :value="scope.row[fieldOne.fieldAliasName]" :width="(fieldOne.styleSet.listFieldValueStyleSet&&fieldOne.styleSet.listFieldValueStyleSet.width)?fieldOne.styleSet.listFieldValueStyleSet.width:1" :height="(fieldOne.styleSet.listFieldValueStyleSet&&fieldOne.styleSet.listFieldValueStyleSet.height)?fieldOne.styleSet.listFieldValueStyleSet.height:50" :fontSize="(fieldOne.styleSet.listFieldValueStyleSet&&fieldOne.styleSet.listFieldValueStyleSet.fontSize)?fieldOne.styleSet.listFieldValueStyleSet.fontSize:'0px'"></barcode>
                        </div>
                        <div v-else-if="(fieldOne.styleSet.cssStyle == 18)" :style="fieldOne.styleSet.listFieldStyleSet?fieldInfo.styleSet.listFieldStyleSet.styleSetCode:''" kwName="listFieldStyleSet">
                            <el-link type="primary" @click="toPreviewFile(scope.row,fieldOne)">{{scope.row[fieldOne.fieldAliasName]}}</el-link>
                        </div>
                        <div v-else-if="(fieldOne.styleSet.cssStyle == 19)" :style="fieldOne.styleSet.listFieldStyleSet?fieldInfo.styleSet.listFieldStyleSet.styleSetCode:''" kwName="listFieldStyleSet" v-html="scope.row[fieldOne.fieldAliasName]">
                            
                        </div> -->
                        <span v-else>
                            {{scope.row[fieldOne.fieldAliasName]}}
                        </span>
                    </template>
                </el-table-column>
            </template>
            <!-- 子表格的显示方式如果未 childTabShowWay 表格右侧追加列 -->
            <template v-if="pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.childTabShowWay==2">
                <el-table-column  v-for="(childTabOne,childTabIndex) in pageSetInfo.childTabs" :key="'childTab_'+childTabIndex"
                    :label="childTabOne.childPageName"
                    width="400"
                    class-name="vertiacl_top1"
                >   
                    <template  slot-scope="scope">
                        <kw_list :initPageObj="{
                            'pageId':childTabOne.pageId,
                            'tableId':childTabOne.tableId,
                            'pageType':1,
                            'mainTableId':pageSetInfo.tableId,
                            'mainPageId':pageSetInfo.pageId
                        }" :mainId="scope.row['T_' + pageSetInfo.tableId + '_0']" :isLimitButton="isLimitButton"></kw_list>
                    </template>
                </el-table-column>
            </template>
      </el-table>
    </template>
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="90%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
        <template slot="title"> 
            <div>
                {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (tableMaxHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
            <el-button @click="dialogIframeZdyCancel">取 消</el-button>
            <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 文件预览组件 -->
    <el-dialog class="zdy_dialog" :modal="false" v-if="filePreviewInfo.ifLoad" v-show="filePreviewInfo.ifShow" :title="filePreviewInfo.name" :visible.sync="filePreviewInfo.ifLoad" width="100%" top="1vh" center append-to-body v-dialogDrag>
      <kw_file_preview v-model="filePreviewInfo"></kw_file_preview>
    </el-dialog>
    
  </div>
</template>

<script>
// 状态聚合组件 
import kw_having_view from '@/components/look/kw_having_view.vue';
// 图片预览组件 kw_preview_image
import kw_preview_image from '@/components/look/kw_preview_image.vue';
// 二维码组件
import vueQr from 'vue-qr'
import VueBarcode from "vue-barcode";
// 文件预览组件
import kw_file_preview from '@/components/kw/kw_file_preview.vue';
//card字段组件 kw_card_field
import kw_card_field from '@/components/list/kw_card_field.vue';

import pageUtils from '@/js/page/pageUtil.js'; 
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_list_default',
  props: {
    pageSetInfo:{
      type: Object,
      value: null
    },
    paginationInfo:{
      type: Object,
      default(){
        return {//分页条数
            pageSize:20,
            //总记录数
            total:0,
            //当前是第几页
            currentPage:1,
            //当前读取了多少条数据
            dataStartNum:0
        }
      }
    },
    dataMaxNum:{
        type:Number,
        default:0
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList:{
      type: Array,
      value: null
    },
    initDataIndex:{
      type: Number,
      value: 0
    },
    // 初始的默认选中值
    initCheckId: {
      type: String,
      value: null
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    var that = this;
    return {
        // 访问来源 PC:2 或者 H5:3
        visitSource:utils.checkVisitSource(that),
        //列表的最大高度
        tableMaxHeight:450,
        // 合并后的按钮组信息
        buttonGroupList:[],
        selectionNodes:[],
        //按钮列的宽度
        buttonWidth:50,
        /**
         * 弹出层组件的信息
         */
        dialogInfo:{
            ifLoad:false
        },
        childTabChooseIndex:"childTab_0",
        /**
         * 文件预览组件的信息
         */
        filePreviewInfo:{
            name:'文件预览',
            ifLoad:false,
            ifShow:false
        },
    };
  },
  created() {
    var that = this;
    //计算页面高度 设置表格的最大高度 tableMaxHeight
    var windowHeight = window.innerHeight-140;
    // var outFieldArr = this.pageSetInfo.outFieldArr;
    // if(outFieldArr && outFieldArr.length > 0) {
    //     var tmpSearchHeight = (Math.ceil(outFieldArr.length/3))*40
    //     windowHeight = windowHeight - tmpSearchHeight;
    // }
    
    // 判断搜索条件个数
    this.tableMaxHeight = windowHeight;
    // 进行按钮组的合并操作
    that.initOperaButtonSet();

    this.updataDataList();
  },
  mounted() {
    var that = this;
    // that.$nextTick(function(){
    //     that.adjustColumnWidth(that.$refs.listTableRef.$el,that.listFieldSet);
    //   })
    // 如果有初始选中值则进行复选框的勾选
    that.initChooseNodes();
  },
  watch:{
    dataList:function(newVal){
        this.updataDataList();
    }
  },
  computed:{
  },
  components: {
    kw_having_view,
    kw_preview_image,
    vueQr,
    'barcode': VueBarcode,
    kw_file_preview,
    kw_card_field,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    styleSetCodeZdy(json,rowData) {
      if(json) {
        var styleSetCode = json.styleSetCode;
        if(json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }
        return styleSetCode;
      } else {
        return "";
      }
    },
    adjustColumnWidth(table,listFieldSet) {
        var that = this;
        const colgroup = table.querySelector("colgroup");
        const colDefs = [...colgroup.querySelectorAll("col")];
        colDefs.forEach((col) => {
            const clsName = col.getAttribute("name");
            const cells = [
            ...table.querySelectorAll(`td.${clsName}`),
            ...table.querySelectorAll(`th.${clsName}`),
            ];
            if (!cells[0].classList.contains("fit_column")) {
            return;
            }
            var fieldIndex = -1;
            cells[0].classList.forEach((className) => {
                if(className.startsWith("fieldIndex_")) {
                    fieldIndex = className.substring(11);
                }
            })
            const widthList = cells.map((el) => {
                var tmpWidth = el.querySelector(".cell")?el.querySelector(".cell").offsetWidth:0;
                if(tmpWidth == 0) {
                    tmpWidth = el.querySelector(".cell")?el.querySelector(".cell").scrollWidth:0;
                }
                // console.log("el.querySelector(.cell).offsetWidth============",clsName,tmpWidth);
                return tmpWidth;
            });
            var max = Math.max(...widthList);
            max = max + 10;
            var sourcelistWidth = null;
            if(fieldIndex >= 0) {
                sourcelistWidth = listFieldSet[fieldIndex].sourcelistWidth;
            } else {
                if(max == 10) {
                    sourcelistWidth = that.buttonWidth;
                } else {
                    sourcelistWidth = max;
                }
            }
            var nowWidth = 0;
            if(fieldIndex >= 0) {
                nowWidth = listFieldSet[fieldIndex].listWidth;
            } else {
                nowWidth = that.buttonWidth;
            }
            if(nowWidth == 0) {
                nowWidth = 100;
            }
            
            var ifUpdate = false;
            if(max > nowWidth) {
                ifUpdate = true;
            } else if(sourcelistWidth && max > sourcelistWidth) {
                ifUpdate = true;
            } else if(sourcelistWidth){
                ifUpdate = true;
                max = sourcelistWidth;
            }
            // console.log("nowWidth=====================================",clsName,nowWidth, sourcelistWidth, max);
            if(ifUpdate) {
                if(listFieldSet.length > fieldIndex && fieldIndex >= 0) {
                    if(!listFieldSet[fieldIndex].sourcelistWidth) {
                        listFieldSet[fieldIndex].sourcelistWidth = listFieldSet[fieldIndex].listWidth;
                    }
                    listFieldSet[fieldIndex].listWidth = max;
                    // console.log("listFieldSet[fieldIndex].listWidth=====================================",listFieldSet[fieldIndex].listWidth);
                } else {
                    that.buttonWidth = max;
                }
            }
        });
    },
    /**
     * 进行数据的结构处理
     */
    updataDataList(){
      var that = this;
      var dataList = this.dataList;
      if (this.dataList) {
        dataList.forEach((dataInfo,dataIndex) => {
          this.listFieldSet.forEach((fieldInfo)=>{
            if(fieldInfo.styleSet != null && (fieldInfo.styleSet.cssStyle == 12 || fieldInfo.styleSet.cssStyle == 14)) {
              if (dataInfo[fieldInfo.fieldAliasName]) {
                var arr = dataInfo[fieldInfo.fieldAliasName].split(",");
                dataInfo[fieldInfo.fieldAliasName] = arr;
              }
            }
          })
        })
      }
      //进行宽度渲染
      that.$nextTick(function(){
        that.adjustColumnWidth(that.$refs.listTableRef.$el,that.listFieldSet);
      })
    //   setTimeout(() => {
    //      that.adjustColumnWidth(that.$refs.listTableRef.$el,that.listFieldSet);
    //     }, 1000);
    },
    /**
     * 是否进行数据合并 数据合并的逻辑
     */
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
        var columnInitLength = 3;
        if(this.pageSetInfo.childTabs && this.pageSetInfo.childTabs.length > 0 && (!this.pageSetInfo.listStyleSet || this.pageSetInfo.listStyleSet.childTabShowWay!='2')) {
            columnInitLength = 4;
        }
        if((this.pageSetInfo.listStyleSet && this.pageSetInfo.listStyleSet.radioIfShow==2) || this.dataMaxNum==1) {
            columnInitLength = columnInitLength - 1;
        }
        if(this.pageSetInfo.listStyleSet && this.pageSetInfo.listStyleSet.indexIfShow==2) {
            columnInitLength = columnInitLength - 1;
        }
        if(!this.pageSetInfo.operaButtonSetIfHide) {
            columnInitLength = columnInitLength - 1; 
        }
        /**
         * 列表数据显示列
         */
        var nowColumnIndex = columnIndex - columnInitLength;
        if(nowColumnIndex >= 0) {
            //获取列的设置信息
            var columnOne = this.listFieldSet[nowColumnIndex];
            if(columnOne != null && columnOne.styleSet && columnOne.styleSet.ifSpanRow == 1) {
                var dataList = this.dataList;
                var rowspan = 1;
                //判断本行数据和上一行数据同列的数据是否相同  如果相同 合并个数设置为0
                if(rowIndex > 0) {
                    if(dataList[rowIndex][(columnOne.fieldType == 4?'DIC_':'')+columnOne.fieldAliasName] == dataList[rowIndex-1][(columnOne.fieldType == 4?'DIC_':'')+columnOne.fieldAliasName]) {
                        rowspan = 0;
                    }
                } 
                //判断本行数据和之后的行的同列 多少行数据相同 设置合并个数
                if(rowspan == 1) {
                    for (let index = rowIndex+1; index < dataList.length; index++) {
                        if(dataList[rowIndex][(columnOne.fieldType == 4?'DIC_':'')+columnOne.fieldAliasName] == dataList[index][(columnOne.fieldType == 4?'DIC_':'')+columnOne.fieldAliasName]) {
                            rowspan ++;
                        } else {
                            break;
                        }
                    }
                }
                if(rowspan > 1) {
                    return {
                        rowspan: rowspan,
                        colspan: 1
                    };
                } else if(rowspan == 0) {
                    return {
                        rowspan: rowspan,
                        colspan: 0
                    };
                }

            }
        }
    },
    /**
     * 如果有初始选中值则进行复选框的勾选
     */
    initChooseNodes(){
        var that = this;
        var initCheckId = that.initCheckId;
        var oneCurrent = "";
        var oneIndex = 0;
        var checkDataInfo = [];
        if (initCheckId && initCheckId != "" && that.dataList.length > 0) {
            if(that.dataMaxNum != 1) {
                var initCheckIdArr = initCheckId.split(",");
                for (var i = 0; i < initCheckIdArr.length; i++) {
                    if(i<that.dataList.length) {
                        var nowCheckEle = that.dataList[i];
                        oneCurrent += (oneCurrent != "" ? "," : "") + nowCheckEle.LMF_ID;
                        checkDataInfo.push(nowCheckEle);
                        that.$refs.listTableRef.toggleRowSelection(nowCheckEle);
                    }
                }
                that.selectionNodes = checkDataInfo;
            } else {
                that.$refs.listTableRef.setCurrentRow(that.dataList[0]);
            }
        }
    },
    /**
     * 进行按钮组的合并操作
     */
    initOperaButtonSet(){
        var buttonWidth = 25;
        if(this.pageSetInfo.operaButtonSet && this.pageSetInfo.operaButtonSet.length > 0) {
            var buttonGroupList = [];
            var noGroupJson = {
                isGroup:false,
                operaButtonSet:[]
            }
            // var ifNoTabName = 0;
            // var lastOneWidth = 0;
            this.pageSetInfo.operaButtonSet.forEach(element => {
                
                if(utils.isNotNull(element.buttonTabName)) {
                    var groupJson = {};
                    if(buttonGroupList.length > 0 && buttonGroupList[buttonGroupList.length-1].buttonTabName == element.buttonTabName) {
                        groupJson = buttonGroupList[buttonGroupList.length-1];
                    } else {
                        groupJson = {
                            rowCol:element.row+"_"+element.col,
                            buttonTabName:element.buttonTabName,
                            isGroup:true,
                            operaButtonSet:[]
                        }
                        buttonWidth += element.buttonTabName.length*13 + 27;
                        buttonGroupList.push(groupJson);
                    }
                    groupJson.operaButtonSet.push(element);
                } else {
                    if(element.ifShow) {
                        // if(ifNoTabName == 0) {
                            // lastOneWidth = element.buttonName.length*13 + 10;
                        // }
                        // ifNoTabName++;
                        buttonWidth += element.buttonName.length*13 + 10;
                    }
                    noGroupJson.operaButtonSet.push(element);
                }
            });
            // if(ifNoTabName > 1) {
            //     lastOneWidth = 56;
            // }
            // if(ifNoTabName > 0) {
            //     buttonWidth += lastOneWidth;
            // } 
            if(noGroupJson.operaButtonSet.length > 0) {
                buttonGroupList.push(noGroupJson);
            }
            this.buttonGroupList = buttonGroupList;
            this.buttonWidth = buttonWidth;
        }
    },
    /**
     * 列表的序列字段 根据分页页数进行计算
     */
    getListIndex(index) {
        return ((this.paginationInfo.currentPage-1)*this.paginationInfo.pageSize)+index+1;
    },
    /**
     * 表头的行样式
     */
    getHeadRowStyle({ row, rowIndex}) {
        // console.log("getHeadRowStyle============================",this.pageSetInfo.listStyleSet.listTableHeadRowStyleSet);
        // return (this.pageSetInfo.listStyleSet.listTableHeadRowStyleSet?this.pageSetInfo.listStyleSet.listTableHeadRowStyleSet.styleSetCode:'');
        return "border: 1px solid #ececec;";
    },
    /**
     * 表头的单元格样式设置
     */
    getHeadCellStyle(json){
        var codeStyle = (this.pageSetInfo.listStyleSet.listTableHeadRowStyleSet?this.pageSetInfo.listStyleSet.listTableHeadRowStyleSet.styleSetCode:'');
        var columnInitLength = 3;
        if(this.pageSetInfo.childTabs && this.pageSetInfo.childTabs.length > 0 && (!this.pageSetInfo.listStyleSet || this.pageSetInfo.listStyleSet.childTabShowWay!='2')) {
            columnInitLength = 4;
        }
        if((this.pageSetInfo.listStyleSet && this.pageSetInfo.listStyleSet.radioIfShow==2) || this.dataMaxNum==1) {
            columnInitLength = columnInitLength - 1;
        }
        if(this.pageSetInfo.listStyleSet && this.pageSetInfo.listStyleSet.indexIfShow==2) {
            columnInitLength = columnInitLength - 1;
        }
        if(!this.pageSetInfo.operaButtonSetIfHide) {
            columnInitLength = columnInitLength-1; 
        }
        /**
         * 列表数据显示列
         */
        var nowColumnIndex = json.columnIndex - columnInitLength;
        if(nowColumnIndex >= 0) {
            //获取列的设置信息
            var columnOne = this.listFieldSet[nowColumnIndex];
            // 判断是否有单独的字段的value样式设置
            if(columnOne && columnOne.styleSet.listFieldNameStyleSet && columnOne.styleSet.listFieldNameStyleSet.styleSetCode) {
                codeStyle = (columnOne.styleSet.listFieldNameStyleSet?columnOne.styleSet.listFieldNameStyleSet.styleSetCode:'');
            }
        }
        if(codeStyle == "" || codeStyle == undefined) {
            // codeStyle = "background:rgb(202 225 255);color:#000;";
            // codeStyle = "background:#409EFF;color:#fff;";
            codeStyle = "background:#f1f4fb;color:#333333;border-right: 1px solid #ddd;";
            
        }
        return codeStyle;
    },
     /**
     * 根据设置的样式进行行的样式返回 
     * 现在主要是设置的行颜色
     */
    getRowStyle({row, rowIndex}) {
        var defaultStyleCode = (this.pageSetInfo.listStyleSet.listTableDataRowStyleSet?this.pageSetInfo.listStyleSet.listTableDataRowStyleSet.styleSetCode:'');
        var rowData = row;
        var rowColorSet = this.pageSetInfo.rowColorSet;
        if(rowColorSet != null && rowColorSet != undefined && rowColorSet != 'undefined') {
            var colorStr = "";
            rowColorSet.forEach(element => {
                if(eval(element.jsWhereStr)) {
                    colorStr = element.color
                }
            });
            if(colorStr != "") {
                defaultStyleCode+="background: #"+colorStr + ";";
            }
        }
        return defaultStyleCode;
        //background: #f0f9eb;
    },
    /**
     * 根据设置的单元格进行单元格的样式返回 
     * 现在主要是设置的列颜色
     */
    getCellStyle(json) {
        var columnInitLength = 3;
        if(this.pageSetInfo.childTabs && this.pageSetInfo.childTabs.length > 0 && (!this.pageSetInfo.listStyleSet || this.pageSetInfo.listStyleSet.childTabShowWay!='2')) {
            columnInitLength = 4;
        }
        if((this.pageSetInfo.listStyleSet && this.pageSetInfo.listStyleSet.radioIfShow==2) || this.dataMaxNum==1) {
            columnInitLength = columnInitLength - 1;
        }
        if(this.pageSetInfo.listStyleSet && this.pageSetInfo.listStyleSet.indexIfShow==2) {
            columnInitLength = columnInitLength - 1;
        }
        if(!this.pageSetInfo.operaButtonSetIfHide) {
            columnInitLength = columnInitLength-1; 
        }
        /**
         * 列表数据显示列
         */
        var nowColumnIndex = json.columnIndex - columnInitLength;
        var codeStyle = this.styleSetCodeZdy(this.pageSetInfo.listStyleSet.listTableDataRowStyleSet,json.row);
        // (this.pageSetInfo.listStyleSet.listTableDataRowStyleSet?this.pageSetInfo.listStyleSet.listTableDataRowStyleSet.styleSetCode:'');
        if(nowColumnIndex >= 0) {
            //获取列的设置信息
            var columnOne = this.listFieldSet[nowColumnIndex];
            if(columnOne != null) {
                var rowData = json.row;
                var rowColorSet = columnOne.fieldTjSet;
                var colorStr = "";
                if(columnOne.defaultColor != null && columnOne.defaultColor != undefined && columnOne.defaultColor.length > 0) {
                    colorStr = columnOne.defaultColor;
                }
                if(rowColorSet != null && rowColorSet != undefined && rowColorSet != 'undefined') {
                    rowColorSet.forEach(element => {
                        if(eval(element.jsWhereStr)) {
                            colorStr = element.color
                        }
                    });
                }
                if(colorStr != "") {
                    codeStyle+="color: #"+colorStr+";";
                }
            }
            // 判断是否有单独的字段的value样式设置
            if(columnOne && columnOne.styleSet.listFieldValueStyleSet) {
                codeStyle =  this.styleSetCodeZdy(columnOne.styleSet.listFieldValueStyleSet,json.row);
                // (columnOne.styleSet.listFieldValueStyleSet?columnOne.styleSet.listFieldValueStyleSet.styleSetCode:'');
            }
        } else if(nowColumnIndex == -1) {
            //操作按钮列 进行按钮显示条件的判断


        }
        return codeStyle;
    },

    /**
     * 表格行单击时，进行复选框的勾选和取消
     */
    tableRowClick(row, event, column){
        this.$refs.listTableRef.toggleRowSelection(row);
    },
    tableRowDblclick(row, event) {
        //双击时 判断如果是单选 则双击的默认选中并关闭弹出层
        if(this.dataMaxNum == 1) {
            this.selectionNodes = [row];
            //调用父级的选中方法
            this.$emit("closeListDialog");
        }
    },
    /**
     * 列表复选框勾选和取消时进行 选中个数的判断 不可大于最大选中个数
     */
    tableSelectionChange(selection){
        //判断选中个数 是否已经达到最大个数要求 如果达到则把最后选中的 取消掉
        if(this.dataMaxNum != undefined && this.dataMaxNum > 0 && selection.length > this.dataMaxNum) {
            this.$message({
                message: '最多可以选中'+this.dataMaxNum+"个!",
                type: 'warning'
            });
            var tmpLength = selection.length;
            for(var i = 0; i < (tmpLength-this.dataMaxNum); i++) {
                this.$refs.listTableRef.toggleRowSelection(selection[i],false);
                selection.splice(i,1);
            }
        }
        if(this.dataMaxNum == 1 && selection.length == this.dataMaxNum) {
            var initCheckId = this.initCheckId;
            if(initCheckId && initCheckId == selection[0]["T_" + this.pageSetInfo.tableId  + "_0"]) {
                selection.splice(0,1);
                pageUtils.listDataClick(this, null);
            } else {
                pageUtils.listDataClick(this, selection[0]);
            }
        }
        this.selectionNodes = selection;
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (buttonOne,dataInfo) {
        console.log("dataInfo=========dataButtonClick=========",dataInfo);
      pageUtils.dataButtonClick(this,buttonOne,dataInfo);
    },
    /**
     * 后台排序
     */
    sortChange:function(info){
        this.$emit("refreshevent",info.prop,(info.order=="ascending"?'asc':'desc'));
    },
    /**
     * 调用列表数据刷新方法
     */
    initLoadDataInfo:function(){
//      this.triggerEvent("refreshevent");
        this.$emit("refreshevent");
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
          this.refreshevent();
      }
    },
    refreshevent() {
        this.$emit("refreshevent");
    },
    /**
     * 获取最外层的的kw_look组件
     */
    getParentKwLook(callback) {
      if(this.$listeners['getParentKwLook']){
        var parentKwLook;
        this.$emit("getParentKwLook",val => {
            parentKwLook = val
        });
        callback(parentKwLook);
      } else {
        callback(null);
      }
    },
    /**
     * 打开文件预览组件
     */
    toPreviewFile:function(dataInfo,fieldone) {
        console.log("fieldone======================",fieldone);
        var that = this;
        var file = {};
        file.name = dataInfo[fieldone.fieldAliasName+"_NAME"];
        file.downAddress = dataInfo[fieldone.fieldAliasName+"_DOWNADDRESS"];
        pageUtils.toPreviewFile(that,file,fieldone);
        // window.open(url);
    },
    /**
     * 隐藏预览组件
     */
    hiddenPreviewDialog:function(){
        this.filePreviewInfo.ifShow = false;
    },
    /**
     * 销毁预览组件
     */
    destoryPreviewDialog:function(){
        this.filePreviewInfo.ifLoad = false;
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vertiacl_top1{
    vertical-align: top !important;
}
.cell_border_color_zdy{
    /* border-bottom: 1px solid #0e0e0e !important; */
    /* border-right: 1px solid #0e0e0e !important; */
    color: #2e2e2e;
}
.table_border_color_zdy{
    /* border: 1px solid #0e0e0e !important; */
}
.cell_head_color_zdy{
    /* border-bottom: 1px solid #0e0e0e !important; */
    /* border-right: 1px solid #0e0e0e !important; */
    background-color: #ecf1ff !important;
    color: #1c1c1c;
}

.el-table .fit_column_class .cell {
    white-space: nowrap !important;
    overflow: auto !important;
}
.el-table .fit_column .cell {
    display: inline-block !important;
    width: auto !important;
}
  
/* .el-table.r-table .el-table__body-wrapper {
  overflow-x: auto !important;
} */
.el-table .el-checkbox__inner{
    border: 1px solid #2a2b2cb8 !important;
}
</style>
